import { ConversationDto } from 'src/app/features/conversation/models/conversation.dto';

/**
 * Name of the agent who most recently handed this conversation to a queue, or null when it was never
 * transferred into a queue.
 *
 * A queue leg is dispatched by mod_fifo from the member's stored dial string, so it cannot carry the
 * `X-CX-Transfer-From` header a transfer aimed straight at an agent does — the origin is read back
 * from the conversation instead. A queue transfer is the segment with a transfer type and no target
 * agent.
 */
export function findQueueTransferAgentName(conversation: ConversationDto): string | null {
  const handedToQueue = [...(conversation.segments ?? [])]
    .filter(s => s.transferTypeId != null && s.targetAgentId == null)
    .sort((a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime())
    .pop();

  return handedToQueue?.agentName || null;
}
